import { get, post } from "../../config/api";

class FoodMakingService {       

    static async getRestaurantData(restaurantId) {
        const url = `/v3/dashboard/restaurant/${restaurantId}`;
        return await get({ url });
    }

    static async changeRestaurantServingStatus(restaurantId, restaurantStatusPayload) {
        const url = `/v3/dashboard/restaurant/${restaurantId}/status`;
        return await post({ url, data: restaurantStatusPayload });
    }

}

export default FoodMakingService;